import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Box } from "@mui/material";
import Alert from "@mui/material/Alert";
import TripPort from "../../../components/TripPort";

function CloseTripForm2({ nextStep, handleChange, values }) {
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  const formIsValid = () => {
    const formErrors = {};

    if (Object.keys(values.portcd).length === 0)
      formErrors.port = "Arrival Port is required.";

    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  const _next = (event) => {
    event.preventDefault();
    if (!formIsValid()) return;

    nextStep();
  };

  const _cancel = (event) => {
    event.preventDefault();
    navigate(`${process.env.PUBLIC_URL}/ivr`, {
      state: { trip_id: values.vtr_nbr, vesselNbr: values.permitNbr },
    });
  };

  return (
    <>
      <Box
        display="flex"
        justifyContent="center"
        m={1}
        p={1}
        bgcolor="background.paper"
      >
        <TripPort
          id="port"
          name="port"
          label="Arrival Port"
          value={values.portcd}
          onChange={handleChange("port")}
        />
      </Box>
      {errors.port && <Alert severity="error">{errors.port}</Alert>}
      <Box display="flex" justifyContent="center" m={1} p={1}>
        <Box p={1}>
          <Button variant="contained" className="warningBtn" onClick={_cancel}>
            Cancel
          </Button>
        </Box>
        <Box p={1}>
          <Button variant="contained" className="successBtn" onClick={_next}>
            Continue
          </Button>
        </Box>
      </Box>
    </>
  );
}

export default CloseTripForm2;
